import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { statewise_cities } from '../../utils/statewise_cities';
import { addOrganisationData } from '../../utils/api/organisationAPI';
import { Spinner } from 'react-bootstrap';
import { toast } from 'sonner';
import { motion } from 'framer-motion';

const ENTITY_TYPES = ['Private', 'Public', 'Non-profit', 'Government', 'Startup', 'Other'];
const EMPLOYEE_OPTIONS = ['1-10', '11-50', '51-200', '201-500', '500+'];
const SECTOR_OPTIONS = [
    "Agriculture", "Automotive", "Aerospace", "Banking and Finance", "Construction",
    "Consumer Goods", "Energy", "Healthcare", "Information Technology", "Insurance",
    "Manufacturing", "Media and Entertainment", "Pharmaceuticals", "Retail",
    "Telecommunications", "Transportation and Logistics", "Real Estate", "Education",
    "Tourism and Hospitality", "Legal Services", "Government", "Non-Profit", "Utilities",
    "Technology", "Chemicals", "Food and Beverage", "Mining and Metals", "Textiles"
];

const STATES = Object.keys(statewise_cities);

const InputStatus = () => {
    const [formData, setFormData] = useState({
        name: '',
        entity_type: '',
        noOfEmployees: '',
        sector: '',
        state: '',
        city: '',
        addressLine1: '',
        addressLine2: '',
        pincode: '',
        isSubscribed: false,
        minutesUsed: 0
    });

    const [errors, setErrors] = useState({}); 
    const [isLoading, setIsLoading] = useState(false);
  

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
            ...(name === "state" && { city: "" }) 
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name) newErrors.name = 'Organisation name is required';
        if (!formData.entity_type) newErrors.entity_type = 'Organisation type is required';
        if (!formData.noOfEmployees) newErrors.noOfEmployees = 'Number of employees is required';
        if (!formData.sector) newErrors.sector = 'Sector is required';
        if (!formData.state) newErrors.state = 'State is required';
        if (!formData.city) newErrors.city = 'City is required';
        if (!formData.addressLine1) newErrors.addressLine1 = 'Address Line 1 is required';
        if (!formData.pincode) newErrors.pincode = 'Pincode is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; 
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
          
            addOrganisationData(formData, { setIsLoading })
                .then(res => {
                    const message = res["message"];                 
                    toast.success(message);
                })
                .catch(error => {
                    console.error('Submission failed:', error);
                    toast.error("Submission failed. Please try again.");
                });
        } else {
            toast.error("Please fill all required fields correctly.");
        }
    };
    


    const cities = statewise_cities[formData.state] || [];

    return (
        <motion.div 
        initial={{
            opacity: 0
        }}
        animate={{
            opacity: 1

        }}
        transition={{
            duration: 1
        }}
        className="col-lg-12">
            <div className="card" style={cardStyle}>
                <div className="card-header" style={cardHeaderStyle}>
                    <h5 className="card-title mb-0" style={titleStyle}>
                        <Icon icon="lucide:building" style={{ verticalAlign: 'middle', marginRight: '10px' }} width="22" height="22" />
                        Organisation Form
                    </h5>
                </div>
                <div className="card-body" style={cardBodyStyle}>
                    <form className="row gy-4" onSubmit={handleSubmit}>
                        {/* Name */}
                        <div className="col-md-6">
                            <label className="form-label" style={labelStyle}>Organisation Name</label>
                            <div style={{ position: 'relative' }}>
                                <Icon icon="lucide:briefcase" width="18" height="18" style={iconStyle} />
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter name"
                                    required
                                    style={inputStyle}
                                />
                                {errors.name && <div className="text-danger">{errors.name}</div>}
                            </div>
                        </div>

                        {/* Entity Type */}
                        <div className="col-md-6">
                            <label className="form-label" style={labelStyle}>Organisation Type</label>
                            <div className="position-relative">
                                <Icon icon="lucide:building-2" width="18" height="18" style={iconStyle} />
                                <select
                                    name="entity_type"
                                    value={formData.entity_type}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    style={selectStyle}
                                >
                                    <option value="">Select Organisation type</option>
                                    {ENTITY_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
                                </select>
                                {errors.entity_type && <div className="text-danger">{errors.entity_type}</div>}
                                <Icon icon="lucide:chevron-down" width="18" height="18" style={dropdownIconStyle} />
                            </div>
                        </div>

                        {/* Employees */}
                        <div className="col-md-6">
                            <label className="form-label" style={labelStyle}>Number of Employees</label>
                            <div className="position-relative">
                                <Icon icon="lucide:users" width="18" height="18" style={iconStyle} />
                                <select
                                    name="noOfEmployees"
                                    value={formData.noOfEmployees}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    style={selectStyle}
                                >
                                    <option value="">Select number</option>
                                    {EMPLOYEE_OPTIONS.map((range, index) => <option key={index} value={range}>{range}</option>)}
                                </select>
                                {errors.noOfEmployees && <div className="text-danger">{errors.noOfEmployees}</div>}
                                <Icon icon="lucide:chevron-down" width="18" height="18" style={dropdownIconStyle} />
                            </div>
                        </div>

                        {/* Sector */}
                        <div className="col-md-6">
                            <label className="form-label" style={labelStyle}>Sector</label>
                            <div className="position-relative">
                                <Icon icon="lucide:briefcase" width="18" height="18" style={iconStyle} />
                                <select
                                    name="sector"
                                    value={formData.sector}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    style={selectStyle}
                                >
                                    <option value="">Select Sector</option>
                                    {SECTOR_OPTIONS.map(sector => <option key={sector} value={sector}>{sector}</option>)}
                                </select>
                                {errors.sector && <div className="text-danger">{errors.sector}</div>}
                                <Icon icon="lucide:chevron-down" width="18" height="18" style={dropdownIconStyle} />
                            </div>
                        </div>

                        {/* State */}
                        <div className="col-md-6">
                            <label className="form-label" style={labelStyle}>State</label>
                            <div className="position-relative">
                                <Icon icon="lucide:map" width="18" height="18" style={iconStyle} />
                                <select
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    style={selectStyle}
                                >
                                    <option value="">Select State</option>
                                    {STATES.map((state, index) => <option key={state+index} value={state}>{state}</option>)}
                                </select>
                                {errors.state && <div className="text-danger">{errors.state}</div>}
                                <Icon icon="lucide:chevron-down" width="18" height="18" style={dropdownIconStyle} />
                            </div>
                        </div>

                        {/* City */}
                        <div className="col-md-6">
                            <label className="form-label" style={labelStyle}>City</label>
                            <div className="position-relative">
                                <Icon icon="lucide:map-pin" width="18" height="18" style={iconStyle} />
                                <select
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    disabled={!formData.state}
                                    style={selectStyle}
                                >
                                    <option value="">Select City</option>
                                    {cities.map((city, index) => <option key={city+index} value={city}>{city}</option>)}
                                </select>
                                {errors.city && <div className="text-danger">{errors.city}</div>}
                                <Icon icon="lucide:chevron-down" width="18" height="18" style={dropdownIconStyle} />
                            </div>
                        </div>

                        {/* Address Line 1 */}
                        <div className="col-12">
                            <label className="form-label" style={labelStyle}>Address</label>
                            <div style={{ position: 'relative' }}>
                                <Icon icon="lucide:home" width="18" height="18" style={iconStyle} />
                                <input
                                    type="text"
                                    name="addressLine1"
                                    value={formData.addressLine1}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter address line 1"
                                    required
                                    style={inputStyle}
                                />
                                {errors.addressLine1 && <div className="text-danger">{errors.addressLine1}</div>}
                            </div>
                        </div>
                        <div className="col-12">

                            <div style={{ position: 'relative' }}>
                                <Icon icon="lucide:home" width="18" height="18" style={iconStyle} />
                                <input
                                    type="text"
                                    name="addressLine2"
                                    value={formData.addressLine2}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter address line 2"
                                    required
                                    style={inputStyle}
                                />
                                {errors.addressLine1 && <div className="text-danger">{errors.addressLine2}</div>}
                            </div>
                        </div>

                        {/* Pincode */}
                        <div className="col-12">
                            <label className="form-label" style={labelStyle}>Pincode</label>
                            <div style={{ position: 'relative' }}>
                                <Icon icon="lucide:map-pin" width="18" height="18" style={iconStyle} />
                                <input
                                    type="number"
                                    name="pincode"
                                    value={formData.pincode}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter pincode"
                                    required
                                    style={inputStyle}
                                />
                                {errors.pincode && <div className="text-danger">{errors.pincode}</div>}
                            </div>
                        </div>

                        <div style={footerStyle}>
                            <button
                                className="btn btn-primary"
                                type="submit"
                                style={submitBtnStyle}
                                disabled={isLoading}
                            >
                                {isLoading ? '' : <Icon icon="lucide:save" width="18" height="18" />}
                                {isLoading ? <Spinner/> : 'Submit'}
                                
                            </button>
                        </div>
                    </form>
                   
                </div>
            </div>
        </motion.div>
    );
};


const labelStyle = {
    fontWeight: '500',
    marginBottom: '8px',
    color: '#344767',
    fontSize: '14px'
};

const iconStyle = {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#6c757d'
};

const inputStyle = {
    paddingLeft: '40px',
    height: '45px',
    borderColor: '#e1e5eb',
    fontSize: '14px'
};

const selectStyle = {
    paddingLeft: '40px',
    height: '45px',
    appearance: 'none',
    borderColor: '#e1e5eb',
    fontSize: '14px'
};

const dropdownIconStyle = {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    color: '#6c757d'
};

const footerStyle = {
    background: '#ffffff',
    padding: '20px 25px',
    borderTop: '1px solid #eaeaea',
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
    display: 'flex',
    justifyContent: 'flex-end'
};

const submitBtnStyle = {
    padding: '12px 30px',
    fontWeight: '500',
    fontSize: '15px',
    borderRadius: '6px',
    background: 'var(--primary-500)',
    border: 'none',
    boxShadow: '0 4px 8px rgba(98, 89, 202, 0.3)',
    transition: 'all 0.3s ease',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
};

const cardStyle = {
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    border: 'none'
};

const cardHeaderStyle = {
    background: '#f8f9fa',
    borderBottom: '1px solid #eaeaea',
    padding: '20px 25px'
};

const cardBodyStyle = {
    padding: '30px 25px',
    background: '#ffffff'
};

const titleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#344767'
};


export default InputStatus;
